import { useEffect, useRef, useState } from "react";
import { Alert, Button, Col, Container, Form, Row } from "react-bootstrap";
import Auth from "../classes/Auth";
import RecaptchaUtil from "../utils/RecaptchaUtil";
import Validator from "../utils/Validator";
import strings from "../strings";
import "../styles/ForgotPasswordView.css";

function ForgotPasswordView() {
	const emailRef = useRef();
	const [emailSent, setEmailSent] = useState(false);
	const [alert, setAlert] = useState("");
	const [alertType, setAlertType] = useState("");
	const [errors, setErrors] = useState({});

	const closeAlert = () => {
		setAlert("");
		setAlertType("");

		if (emailRef.current) {
			emailRef.current.focus();
		}
	};

	const trimFields = () => {
		emailRef.current.value = emailRef.current.value.trim();
	};

	const formValidation = () => {
		let errorMessages = {};
		let firstErrorField = null;

		if (emailRef.current.value.length === 0) {
			errorMessages.email = strings.requiredField;
			firstErrorField = emailRef;
		}

		if (emailRef.current.value.length > 0 && !Validator.isEmailValid(emailRef.current.value)) {
			errorMessages.email = strings.invalidEmailFormat;
			if (!firstErrorField) {
				firstErrorField = emailRef;
			}
		}

		return {errorMessages, firstErrorField};
	}

	const forgotPassword = async (event) => {
		event.preventDefault();
		setAlert("");
		setAlertType("");
		trimFields();

		const {errorMessages, firstErrorField} = formValidation();
		if (Object.keys(errorMessages).length > 0) {
			(firstErrorField ? firstErrorField : emailRef).current.focus();
			setErrors(errorMessages);
		} else {
			Auth.forgotPassword(emailRef.current.value)
				.then((result) => {
					if (result) {
						switch (result.status) {
							case 201:
								setEmailSent(true);
								break;
							case 400:
							case 422:
								setAlertType("warning");
								setAlert(strings.requestFailed);
								break;
							case 403:
								setAlertType("danger");
								setAlert(strings.recaptchaValidationFailed);
								break;
							case 404:
								setAlertType("warning");
								setAlert(strings.emailNotRegistered);
								break;
							case 500:
								setAlertType("danger");
								setAlert(strings.serverError);
								break;
							default:
						}
					}

					if (emailRef.current) {
						emailRef.current.focus();
					}
				});
		}
	};
	
	useEffect(() => {
		if (emailRef.current) {
			emailRef.current.focus();
		}

		const script = RecaptchaUtil.load();
		return () => RecaptchaUtil.cleanUp(script);
	}, []);

	return (
		<Container className="public-inner-container public-inner-container-size px-4 px-md-5 py-4 py-md-5">
			{
				(alert) &&
					<Row className="mb-3">
						<Col className="px-2 px-md-4 px-xl-5">
							<Alert variant={alertType} className="mb-0 user-select-none transparent-cursor" dismissible={true} onClose={closeAlert}>{alert}</Alert>
						</Col>
					</Row>
			}
			<Row className="user-select-none transparent-cursor">
				<Col className="px-2 px-md-4 px-xl-5">
					<span className="public-inner-container-title">{strings.forgotPassword}</span><br />
					{(!emailSent) && <span>{strings.enterYourEmailToResetYourPassword}</span>}
				</Col>
			</Row>
			{
				(emailSent) ?
					<Row className="mt-4">
						<Col id="email-successfully-sent" className="px-2 px-md-4 px-xl-5 user-select-none transparent-cursor">
							{strings.emailSuccessfullySent}
						</Col>
					</Row>
				:
					<Form className="mt-4 d-grid gap-3" onSubmit={forgotPassword}>
						<Row>
							<Col className="px-2 px-md-4 px-xl-5">
								<Form.Group>
									<Form.Control type="text" id="forgot-password-email" className={`${(errors.email) ? "error-border" : ""}`} placeholder={`${strings.email}*`} ref={emailRef} onChange={() => setErrors({...errors, email: false})} />
									{(errors.email) && <Form.Label className="error-label mb-0 user-select-none transparent-cursor" htmlFor="forgot-password-email">{errors.email}</Form.Label>}
								</Form.Group>
							</Col>
						</Row>
						<Row>
							<Col className="px-2 px-md-4 px-xl-5">
								<Button type="submit" className="w-100">{strings.next}</Button>
							</Col>
						</Row>
						<Row className="mt-3">
							<Col id="required-fields-text" className="px-2 px-sm-4 px-xl-5 user-select-none transparent-cursor">
								{strings.theFieldsMarkedWithAnAsteriskAreRequired}
							</Col>
						</Row>
					</Form>
			}
		</Container>
	);
};

export default ForgotPasswordView;
